import { ref, onMounted, onUnmounted } from 'vue';
export default function useMatchMedia(matchCondition) {
    var isMatch = ref(false);
    var handleMediaQueryChange = function (event) {
        isMatch.value = event.matches;
    };
    var mediaQuery = window.matchMedia(matchCondition);
    onMounted(function () {
        isMatch.value = mediaQuery.matches;
        mediaQuery.addEventListener('change', handleMediaQueryChange);
    });
    onUnmounted(function () {
        mediaQuery.removeEventListener('change', handleMediaQueryChange);
    });
    return isMatch;
}
